import { Injector } from "@angular/core";
import { SystemSettingsService } from "@app/core/services/system-settings.service";
import { of, switchMap } from "rxjs";
import { UserSettingsService } from "@app/core/services/user-settings.service";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { setAppInjector } from "@app/core/functions/app-injector";

/**
 * AppInitializationFactory()
 *
 * This function is invoked during application initialization / load.
 *
 * The purpose of this factory implemenation is to establish system settings required
 * by the application before displaying any screen.
 *
 * @param app
 */
export function AppInitializationFactory(
  injector: Injector,
  sysSettingsService: SystemSettingsService,
  userService: UserSettingsService,
  authService: AuthenticationService
) {
  // Set global app injector
  setAppInjector(injector);

  return () =>
    sysSettingsService.loadSettings().pipe(
      switchMap(() => {
        if (authService.isAuthenticated()) {
          return userService.loadSettings();
        }
        return of(null);
      })
    );
}
